module.exports = __webpack_public_path__ + "static/media/noagricolas.25158083.pdf";